import { Link } from 'gatsby'
// import React from 'react'
import Primarybutton from '../Primarybutton'
import { isBrowser } from '../../../utils'
import AppLogo from './logo.webp'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

const Header = () => {
  const ref = useRef()
  const headerNavRef = useRef()

  let prevScrollpos = typeof window !== 'undefined' ? window.pageYOffset : 0

  const handleScrollChange = () => {
    if (
      ref.current &&
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    ) {
      const maxScroll = document.body.clientHeight - window.innerHeight
      let currentScrollPos = window.pageYOffset
      const isScolledDown = maxScroll > 0 && prevScrollpos > currentScrollPos

      if (window.innerWidth > 700) {
        if (isScolledDown) {
          document.getElementById('menu-header').style.top = '0px'
          document.getElementById('menu-header').style.left = '0'
        } else {
          document.getElementById('menu-header').style.left = '0'
          document.getElementById('menu-header').style.top = '-1000px'
        }
      }

      prevScrollpos = currentScrollPos
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScrollChange)
    }

    return () => {
      window.removeEventListener('scroll', handleScrollChange)
    }
  }, [])

  const getMenuDirection = () => {
    if (typeof window !== 'undefined') {
      return window.innerHeight > 1700 ? 'bottom' : 'top'
    }
  }
  return (
    <header className="header" id="menu-header" ref={ref}>
      <div className="header__wrapper">
        <div className="header__logo__burgerWrap">
          <a href="/" className="header__logoContainer">
            {/* <Link to='/'/> */}
            <img src={AppLogo} alt="Magic Task" />
          </a>

          <FontAwesomeIcon
            className="header__logo__burgerWrap__burger"
            icon={faBars}
            onClick={() => {
              // alert(`height is --> ${headerNavRef.current.style.maxHeight}`)
              if (window && window.innerWidth <= 996) {
                if (
                  headerNavRef.current.style.maxHeight === '0px' ||
                  headerNavRef.current.style.maxHeight === ''
                ) {
                  headerNavRef.current.style.maxHeight = '1000px'
                  headerNavRef.current.style.paddingTop = '10px'
                } else {
                  headerNavRef.current.style.maxHeight = '0px'
                  headerNavRef.current.style.paddingTop = '0px'
                }
              }
            }}
          />
          {/* <button >
          </button> */}
        </div>

        <div ref={headerNavRef} className="header__navContainer">
          <nav className="header__nav">
            <a href="/whats-new/">What's New</a>
            <a href="https://discord.com/invite/VgpRh3EcK5/" target={'_blank'}>
              Join Our Discord
            </a>

            <Link to="/blog/" className="parent-page">
              Blog
            </Link>

            <Link to="/ebooks/become-the-goat-of-productivity/" className="parent-page">
              E-book
            </Link>

            <Primarybutton
              buttonText={'Get Started'}
              customClass={'header__nav__btn'}
              buttonLink={'https://app.magictask.io'}
              buttonId={'nav'}
              direction={getMenuDirection()}
            />
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
